<template>
    <Head
        title="Referral Program | vidfaceswap"
        description="Share your unique referral link, earn credits when your connections make their first purchase. Join now!"
        :appendAppName="false"
        :url="route('landing.referral-program.index')"
        :canonical="route('landing.referral-program.index')"
        :image="{
            url: '/images/og-068742z3inr9.webp',
            type: 'image/webp',
            width: 1200,
            height: 630,
            alt: 'vidfaceswap',
        }"
        keywords="deepfake, face swap, vidfaceswap, AI"
    />

    <div class="min-h-screen bg-gray-900">
        <main>
            <div class="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
                <h2 class="text-4xl font-bold tracking-tight text-white sm:text-6xl">
                    Referral Program
                </h2>

                <p class="mt-10 max-w-2xl text-lg leading-8 text-gray-300">
                    Share your unique referral link with friends, family, or colleagues. When
                    someone registers using your link and makes their first credit purchase, you
                    earn credits equal to the amount of their first purchase, as a thank you for
                    spreading the word about our platform. The more you share, the more you earn!
                </p>

                <a :href="route('app.referrals.index')">
                    <Button size="xl" class="mt-10">Get your referral link</Button>
                </a>

                <div class="mt-16">
                    <dl
                        class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3"
                    >
                        <div v-for="step in steps" :key="step.title" class="flex flex-col">
                            <dt class="text-base font-semibold leading-7 text-white">
                                <div
                                    class="mb-6 flex h-10 w-10 items-center justify-center rounded-lg bg-indigo-500"
                                >
                                    <component
                                        :is="step.icon"
                                        class="h-6 w-6 text-white"
                                        aria-hidden="true"
                                    />
                                </div>
                                {{ step.name }}
                            </dt>
                            <dd class="mt-1 text-base leading-7 text-gray-300">
                                <p>{{ step.description }}</p>
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </main>
    </div>
</template>

<script setup>
import Button from '@/Components/Button.vue'
import { CurrencyDollarIcon, GiftIcon, ShareIcon } from '@heroicons/vue/24/outline'
import Head from '@/Components/Head.vue'

const steps = [
    {
        name: 'Step 1: Share your link',
        description:
            'Copy your unique referral link and share it with your friends, family, or colleagues. Encourage them to register on vidfaceswap using your link.',
        icon: ShareIcon,
    },
    {
        name: "Step 2: Referee's first purchase",
        description:
            'When someone registers with your link and makes their first credit purchase, you earn credits as a token of our appreciation for your referral.',
        icon: CurrencyDollarIcon,
    },
    {
        name: 'Step 3: Earn your first purchase credits',
        description:
            "As soon as your referee completes their first credit purchase, you'll be rewarded with the same amount in credits. Enjoy your earnings!",
        href: '#',
        icon: GiftIcon,
    },
]
</script>
